import * as R from 'ramda'
// helper
import { Typography } from '@mui/material'
import { MouseEvent } from 'react'
import { openUserProfile } from '$logic/router'
import { parseHyperlinkText, parseHyperLinkValue } from '$func/hyper-link'
import { handleLink } from '$logic/router/url'
import { showLinkMenu } from '$comp/modals/menus/link-menu'

const onClick = (rawText: string) => {
  const secondPart = parseHyperLinkValue(rawText)
  if (R.startsWith('mention://user_id/', secondPart)) {
    const userId = R.last(R.split('mention://user_id/', secondPart)) as string
    openUserProfile(userId)
  } else {
    handleLink(secondPart)
  }
}

const onContextMenu = (rawText: string) => {
  const secondPart = parseHyperLinkValue(rawText)
  if (R.startsWith('mention://user_id/', secondPart)) {
    return
  }
  showLinkMenu({ link: secondPart })
}

export function hyperLinkRenderer(key: string, result: string[]) {
  const text = parseHyperlinkText(result[0])
  return (
    <Typography
      key={key}
      variant="paragraph3"
      color="var(--hyper-text-color)"
      sx={{ cursor: 'pointer', fontSize: '14px' }}
      onClick={() => onClick(result[0])}
      onContextMenu={(e: MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        onContextMenu(result[0])
      }}
      dir="ltr"
    >
      {text}
    </Typography>
  )
}
